var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationBlackArrow = function SvgLocationBlackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "5px",
    viewBox: "0 0 8 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.800000012
  }, /*#__PURE__*/React.createElement("g", {
    id: "open-Vehicle-",
    transform: "translate(-332.000000, -150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-/-expand_less",
    transform: "translate(336.000000, 152.000000) scale(1, -1) translate(-336.000000, -152.000000) translate(328.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_expand_less-copy-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Bounds",
    fillOpacity: 0.1,
    fill: "#000000",
    opacity: 0,
    points: "0 0 16 0 16 16 0 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#000000",
    points: "8 5 4 9.048583 4.94 10 8 6.90958165 11.06 10 12 9.048583"
  })))))));
};
export { SvgLocationBlackArrow as ReactComponent };
export default __webpack_public_path__ + "assets/70fb1ac1.svg";